import { useCallback } from "react";
import api from "../config/api/axiosConfig";
import type { UpdateUserDTO } from "../types/User";

export const useUserApi = () => {
  // ✅ Login
  const loginUser = useCallback(async (username: string, password: string) => {
    const response = await api.post("/User/login", { username, password });
    return response;
  }, []);

  // ✅ Forgot password
  const forgotPassword = useCallback(async (email: string) => {
    const response = await api.post(`/User/forgot-password?email=${email}`);
    return response;
  }, []);

  // ✅ Register new account
  const registerAccount = useCallback(
    async (
      username: string,
      password: string,
      email: string,
      fontenehusCode: string,
      displayName: string,
      fontenehusId?: number | null,
    ) => {
      const response = await api.post("/User", {
        username,
        password,
        email,
        fontenehusCode,
        displayName,
        fontenehusId,
        anonymousSuggestions: false,
      });
      return response;
    },
    [],
  );

  // ✅ Register new account
  const updateUser = useCallback(
    async (userDTO: UpdateUserDTO, userId: number) => {
      const response = await api.patch("/User/" + userId, userDTO);
      return response;
    },
    [],
  );

  // ✅ Resend email verification
  const resendVerification = useCallback(async (username: string) => {
    const response = await api.post("/User/resend-verification", { username });
    return response;
  }, []);

  const getUserByUserId = useCallback(async (userId: number | undefined) => {
    const response = await api.get("/User/" + userId);
    return response;
  }, []);

  const ChangePasswordWithResetToken = useCallback(
    async (token: string, password: string) => {
      const response = await api.post("/User/ChangePasswordWithResetToken", {
        token,
        newPassword: password,
      });
      return response;
    },
    [],
  );

    // ✅ Change password (logged-in user)
  const changePassword = useCallback(
    async (userId: number, oldPassword: string, newPassword: string) => {
      const response = await api.post(`/User/ChangePassword/${userId}`, {
        oldPassword,
        newPassword,
      });
      return response;
    },
    [],
  );


  const anonymizeUser = useCallback(async (userId: number | undefined) => {
    const response = await api.delete("/User/" + userId);
    return response;
  }, []);

  return {
    loginUser,
    changePassword,
    anonymizeUser,
    forgotPassword,
    registerAccount,
    resendVerification,
    ChangePasswordWithResetToken,
    getUserByUserId,
    updateUser,
  };
};
